<template>
    <div>
      <list
        row-key="RecordId"
        ref="list"
        unit="会员分析"
        :expand-all-row="true"
        :page="page"
        :query-params="params"
        :show-checkbox="$permission.canDel()"
        :show-query="showQuery"
        :get-data-func="getDataFunc"
      >
        <template slot="toolbar-right">
          <slot name="toolbar-right"></slot>
        </template>
        <template slot="query">
          
          <el-form-item label="分析类型">
            <el-select v-model="params.IntegralType" placeholder="请选择分析类型" clearable>
              <el-option label="活跃用户" :value="1"></el-option>
              <el-option label="睡眠用户" :value="0"></el-option>
            </el-select>
          </el-form-item>
           <el-form-item label="分析维度">
            <el-select v-model="params.IntegralType" placeholder="请选择分析维度" clearable>
              <el-option label="按时间段" :value="1"></el-option>
              <el-option label="按消费量" :value="0"></el-option>
            </el-select>
          </el-form-item>
         
          
        </template>
        <template slot="table">
          <el-table-column prop="TimeRange" label="时间范围" align="center" />
       
          <el-table-column prop="PersonCount" label="会员数量" align="center" />
        <!--  <el-table-column prop="IntegralTime" label="操作时间" />
          <el-table-column prop="Money" label="金额" />
          <el-table-column prop="Notices" label="备注" />  -->
          
          <!-- slot[column] -->
          <slot name="column"></slot>
          <!--/ slot[column]-->
        </template>
      </list>
    </div>
  </template>
  <script>
  import listMixin from "@/mixins/list";
  import list from "@/components/common/list";
  
  export default {
    mixins: [listMixin],
    components: { list },
    data() {
      return {
       // api: require("@/api/person/persongrade").default,
        params: {
         PersonName: "",
         IntegralType: "",
         IntegralStarttime: null,
        IntegralEndtime: null,
        },
      };
    },
    methods: {

    getDataFunc(params) {
      return new Promise((resolve,reject) => {
        resolve({ Data: [{TimeRange:"3个月未消费",PersonCount:"20"},{TimeRange:"6个月未消费",PersonCount:"34"},{TimeRange:"1年以上未消费",PersonCount:"15"}]});
      })
    },
     
    },
  };
  </script>